function CCAExtension(cavv, eciFlag, paResStatus, signatureVerifciation, xid) {
	this.CAVV = cavv;
	this.ECIFlag = eciFlag;
	this.PAResStatus = paResStatus;
	this.SignatureVerification = signatureVerifciation;
	this.XID = xid;
}

module.exports = CCAExtension;


//////////////////
// WEBPACK FOOTER
// ./models/payments/ccaExtension.js
// module id = 45
// module chunks = 0 5 20